import { createQueryStringHook } from "../../../../../stores/useQueryState";
import { useOriginalEquipmentSettings } from "./useOriginalEquipmentSettings";

export const originalEquipmentParamName = "original-equipment";

const useValue = createQueryStringHook(originalEquipmentParamName, "");

export const useOriginalEquipment = (): ReturnType<typeof useValue> => {
  const { originalEquipmentOnly } = useOriginalEquipmentSettings();
  return useValue(originalEquipmentOnly);
};
